import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { HOME } from "@/constants/testIds";

const COLUMNS = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/features", slug: "features" },
      { label: "Pricing", to: "/pricing", slug: "pricing" },
      { label: "Changelog", to: "/changelog", slug: "changelog" },
      { label: "Roadmap", to: "/roadmap", slug: "roadmap" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Docs", to: "/docs", slug: "docs" },
      { label: "Guides", to: "/guides", slug: "guides" },
      { label: "Templates", to: "/templates", slug: "templates" },
      { label: "Marketplace tips", to: "/tips", slug: "tips" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about", slug: "about" },
      { label: "Contact", to: "/contact", slug: "contact" },
      { label: "Privacy", to: "/privacy", slug: "privacy" },
      { label: "Terms", to: "/terms", slug: "terms" },
    ],
  },
];

export function Footer() {
  return (
    <footer
      data-testid={HOME.footer}
      className="border-t border-border bg-background"
    >
      <div className="mx-auto w-full max-w-6xl px-5 py-14 sm:px-8 sm:py-20">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
          <div className="col-span-2 max-w-sm">
            <Logo />
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
              The AI copilot for freelancers. Write proposals, replies, and
              follow-ups that actually win the project.
            </p>
            <p className="mt-6 text-xs text-muted-foreground/80">
              © {new Date().getFullYear()} MACHA. All rights reserved.
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="mb-4 text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.slug}>
                    <Link
                      to={link.to}
                      data-testid={HOME.footerLink(link.slug)}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-border pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-muted-foreground">
            Built for Upwork, Fiverr, Freelancer, Toptal & Contra.
          </p>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-400/80" />
            All systems operational
          </div>
        </div>
      </div>
    </footer>
  );
}
